import React from 'react'

export default function SpinnerOverlay(){
  return (
    <div className={'spinner-overlay'}>
      <span className={'spinner'}/>
    </div>
  )
}